
export default class GijsController

  gijsSpeed = 0.7

  constructor: (@gijs) ->


  moveGijs: (dest) ->
    newPos = ['x', 'y', 'z'].map((axis) =>
      if @gijs.position[axis] < dest[axis]
        @gijs.position[axis] + gijsSpeed
      else
        @gijs.position[axis] - gijsSpeed
    )
    @gijs.position.set(newPos...)

    [rX, rY, rZ] = @gijs.rotation.toArray()
    @gijs.rotation.set(rX + 0.006, rY + 0.008, rZ + 0.013)

